import { c as _c } from "react/compiler-runtime";
import React from 'react';
import usePDPProductLabel from 'data-hooks/usePDPProductLabel';
import PDPGalleryLabelsUI from './PDPGalleryLabelsUI';
const PDPGalleryLabels = () => {
  const $ = _c(6);
  const {
    loading,
    error,
    data: t0
  } = usePDPProductLabel();
  const {
    productLabel,
    productLabelColor
  } = t0;
  if (error) {
    return null;
  }
  const t1 = loading && !productLabel;
  let t2;
  if ($[0] !== productLabel) {
    t2 = productLabel ? [productLabel] : [];
    $[0] = productLabel;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== productLabelColor || $[3] !== t1 || $[4] !== t2) {
    t3 = <PDPGalleryLabelsUI loading={t1} labels={t2} color={productLabelColor} />;
    $[2] = productLabelColor;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default PDPGalleryLabels;